import { render } from "./BrokerTxnsModalPopup.vue?vue&type=template&id=2bde73e2&scoped=true"
import script from "./BrokerTxnsModalPopup.vue?vue&type=script&lang=js"
export * from "./BrokerTxnsModalPopup.vue?vue&type=script&lang=js"

import "./BrokerTxnsModalPopup.vue?vue&type=style&index=0&id=2bde73e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bde73e2"]])

export default __exports__